import KunLoading38 from './src/index'

KunLoading38.install = function (Vue) {
	Vue.component(KunLoading38.name, KunLoading38);
}

export default KunLoading38;
